import { Toast, type ToastComponent } from '@opallabs/lapidary'

export const UploadProgressToast: ToastComponent = (toastProps) => (
  <Toast
    {...toastProps}
    message={`Your file(s) will appear in the text section shortly.`}
    title={`Uploading Files`}
  />
)
